import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faImages } from '@fortawesome/free-solid-svg-icons';
import { AnimatePresence, motion } from 'framer-motion';
import CreatePostModal from '../../pages/Posts/CreatePostModal';
import CreatePackModal from '../../pages/Packs/CreatePackModal';

// El componente ahora recibe 'isOpen' y 'setIsOpen' como props.
const QuickAccessMenu = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation();
  const [isPostModalOpen, setIsPostModalOpen] = useState(false);
  const [isPackModalOpen, setIsPackModalOpen] = useState(false);

  const openPostModal = () => {
    setIsOpen(false);
    setIsPostModalOpen(true);
  };

  const openPackModal = () => {
    setIsOpen(false);
    setIsPackModalOpen(true);
  };

  const closePostModal = () => setIsPostModalOpen(false);
  const closePackModal = () => setIsPackModalOpen(false);

  const menuVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 20 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        staggerChildren: 0.1,
        when: 'beforeChildren',
      },
    },
    exit: { opacity: 0, scale: 0.9, y: 20 },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <>
      {/* El menú ahora se posiciona relativo a la barra de navegación inferior. */}
      <div className="fixed bottom-24 inset-x-0 z-40 flex justify-center lg:hidden">
        <AnimatePresence>
          {isOpen && (
            <motion.div
              variants={menuVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className="flex flex-col items-center gap-3"
            >
              <motion.button
                variants={itemVariants}
                onClick={openPackModal}
                className="flex items-center justify-center gap-3 w-48 bg-white dark:bg-neutral-700 p-3 rounded-full shadow-lg text-neutral-800 dark:text-neutral-100 font-semibold"
              >
                <FontAwesomeIcon icon={faImages} />
                <span>{t('quickAccess.createPack', 'Crear Galería')}</span>
              </motion.button>
              <motion.button
                variants={itemVariants}
                onClick={openPostModal}
                className="flex items-center justify-center gap-3 w-48 bg-white dark:bg-neutral-700 p-3 rounded-full shadow-lg text-neutral-800 dark:text-neutral-100 font-semibold"
              >
                <FontAwesomeIcon icon={faFileAlt} />
                <span>{t('quickAccess.createPost', 'Crear Post')}</span>
              </motion.button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {/* La lógica de los modales se mantiene igual. */}
      {isPostModalOpen && (
        <CreatePostModal onClose={closePostModal} onSuccess={closePostModal} />
      )}
      {isPackModalOpen && (
        <CreatePackModal onClose={closePackModal} onSuccess={closePackModal} />
      )}
    </>
  );
};

export default QuickAccessMenu;
